import React from "react";
import { HashRouter, Switch, Route } from "react-router-dom";
import { connect } from "react-redux";
import {
  apiActions,
  recommendedStoriesActions,
  signinActions
} from "../../actions";
import HeaderSubmenu from "../design/HeaderSubmenu";
import { YellowButton } from "../design/buttons";
import PageSpinner from "../design/Episode/PageSpinner";
import PageMessage from "../design/Episode/PageMessage";
import {
  isCurrentEpisodeLast,
  isNotLogged,
  rootPath,
  toggleFullscreenOpacityClasses,
  modalPaths
} from "./helpers";
import EpisodesControls from "./EpisodesControls";
import SocialControls from "./SocialControls";
import Episode from "./Episode";
import EpisodeNovel from "./EpisodeNovel";
import PortalComponent from "../topBar/PortalComponent";
import MobileUserSubmenu from "../topBar/MobileUserSubmenu";
import UserMenu from "../topBar/UserMenu";
import LoginModal from "../onboarding/LoginModal/";
import SignUpModal from "../onboarding/SignUpModal/";
import UnlockConfirmModal from "../unlocking/UnlockConfirmModal";

class ScrollReader extends React.Component {
  constructor(props) {
    super(props);
    this.props.fetchInitialData();

    this.state = {
      fetchedInitialData: false,
      fetchRecommendedStoriesCalled: false,
      failedToFetch: false
    };
  }

  componentWillReceiveProps(nextProps) {
    if (!!nextProps.currentEpisode.id) {
      this.setState({ fetchedInitialData: true });
    }
    if (nextProps.currentEpisode instanceof Error) {
      var error = nextProps.currentEpisode.message;
      this.setState({ failedToFetch: true });
    }

    if (
      nextProps.isCurrentEpisodeLast &&
      !!nextProps.story.id &&
      nextProps.recommendedStories.bySameAuthor.length === 0 &&
      nextProps.recommendedStories.inSameCategory.length === 0 &&
      !this.state.fetchRecommendedStoriesCalled
    ) {
      this.setState({ fetchRecommendedStoriesCalled: true });
      this.props.recommendedStoriesFetchData(nextProps.story.id);
    }
  }

  render() {
    const readyForUnlock =
      this.state.fetchedInitialData &&
      this.props.currentUser.user !== undefined;
    const blockModal = this.props.modalOpened || this.props.processing;
    return (
      <div>
        <PortalComponent destinationDomId={this.props.userMenuDomId}>
          <UserMenu />
        </PortalComponent>
        <PortalComponent destinationDomId={this.props.mobileUserSubmenuDomId}>
          <MobileUserSubmenu />
        </PortalComponent>
        <HeaderSubmenu
          onMouseOut={this.props.onMouseOut}
          onMouseOver={this.props.onMouseOver}
          rootPath={rootPath()}
        >
          {this.state.fetchedInitialData && <EpisodesControls />}
          {this.state.fetchedInitialData && <SocialControls />}
        </HeaderSubmenu>

        <HashRouter>
          <Switch>
            <Route
              path={modalPaths.signIn}
              render={({ location }) => (
                <LoginModal
                  location={location}
                  blockModal={blockModal}
                  success={this.props.successLogin}
                />
              )}
            />
            <Route
              path={modalPaths.signUp}
              render={({ location }) => (
                <SignUpModal
                  location={location}
                  blockModal={blockModal}
                  success={this.props.successSignup}
                />
              )}
            />
            <Route
              path={modalPaths.unlock}
              render={props => (
                <UnlockConfirmModal
                  ready={readyForUnlock}
                  blockModal={blockModal}
                />
              )}
            />
          </Switch>
        </HashRouter>

        {this.state.fetchedInitialData &&
          (this.props.story.publication_type === "novel" ? (
            <EpisodeNovel />
          ) : (
            <Episode />
          ))}
        {!this.state.fetchedInitialData && !this.state.failedToFetch && (
          <PageSpinner className="t-mt7" />
        )}
        {this.state.failedToFetch && (
          <PageMessage className="t-mt5 max-width-4 mx-auto px1 py1">
            <h2>Something's wrong here...</h2>
            <p>We can't find the page you are looking for</p>
            <YellowButton text="Take me away" path="/" onClick={false} />
          </PageMessage>
        )}
      </div>
    );
  }
}

const mapState = (state, ownProps) => ({
  successLogin: state.signin.errorMsg === "",
  successSignup: state.signin.errorSignUpMsg === "",
  modalOpened: state.signin.modalOpened,
  processing: state.processing,
  callback: state.signin.callback,
  callbackType: state.signin.callbackType,
  callbackArgs: state.signin.callbackArgs,
  currentEpisode: state.currentEpisode,
  currentUser: state.currentUser,
  onMouseOut: () => {
    toggleFullscreenOpacityClasses("remove");
  },
  onMouseOver: () => {
    toggleFullscreenOpacityClasses("add");
  },
  isCurrentEpisodeLast: isCurrentEpisodeLast(state),
  mobileUserSubmenuDomId: "mobile-user-submenu",
  userMenuDomId: "webreader-user-menu",
  ...state
});

const mapDispatch = (dispatch, ownProps) => ({
  fetchInitialData: () => {
    dispatch(apiActions.fetchInitialData());
  },
  recommendedStoriesFetchData: storyId => {
    dispatch(recommendedStoriesActions.recommendedStoriesFetchData(storyId));
  }
});

export default connect(mapState, mapDispatch)(ScrollReader);
